// Get the browser locale
function getBrowserLocales(options = {}) {
	const defaultOptions = {
		languageCodeOnly: false,
	};

	const opt = {
		...defaultOptions,

		...options,
	};

	const browserLocales =
		navigator.languages === undefined
			? [navigator.language]
			: navigator.languages;

	if (!browserLocales) {
		return undefined;
	}

	return browserLocales.map((locale) => {
		const trimmedLocale = locale.trim();

		return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale;
	});
}

const browserLocales = getBrowserLocales();
const defaultLocale = browserLocales[0];

const defaultFormatter = new Intl.NumberFormat(defaultLocale, {
	style: 'currency',
	currency: 'EUR',
});

export const formatCurrencyToDefault = (value: number) => {
	return formatCurrency(value, 'EUR');
};

export const formatCurrency = (value: number, currency: string) => {
	let fractionDigits = 2;
	
	if (value !== 0 && Math.abs(value) < 0.01) {
		// Calculate the number of decimals needed to show at least two non-zero digits, capped at 6.
		// For 0.0008, log10(0.0008) = -3.09 => floor(-3.09) = -4 => abs(-4) = 4.
		fractionDigits = Math.min(6, Math.abs(Math.floor(Math.log10(Math.abs(value)))) + 1);
	}

  const formatter = new Intl.NumberFormat(defaultLocale, {
		style: 'currency',
		currency: currency,
		minimumFractionDigits: 2,
		maximumFractionDigits: fractionDigits,
	});
	return formatter.format(value);
};

export const formatCurrencyUnitPrice = (value: number) => {
	const formatter = new Intl.NumberFormat(defaultLocale, {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 2,
		maximumFractionDigits: 6
	});
	return formatter.format(value);
};
